import { PipesModule } from './../../pipes/pipes.module';
import { CommonComponentsModule } from './../common/common.module';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { OrderTypeComponent } from './order-type.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './order-type.routing';
import { FormsModule } from '@angular/forms';
@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        AccordionModule.forRoot(),
        CommonComponentsModule,
        PipesModule
    ],
    declarations: [
        OrderTypeComponent 
    ],
    exports: [
    ],
    providers:[
        BsModalRef
    ]
})

export class OrderTypeModule {}
